import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { class: "fill-height" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        cols: "12",
        class: "d-flex align-end justify-center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_img, {
            src: _ctx.logo,
            height: "150px",
            class: "mb-3"
          }, null, 8, ["src"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        class: "d-flex align-start justify-center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                class: "d-flex justify-center"
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createElementVNode("h2", null, "Site actuellement en maintenance", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                class: "d-flex justify-center"
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode(" Le site est actuellement en maintenance, revenez un peu plus tard! ")
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                class: "d-flex justify-center"
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createElementVNode("div", { class: "animation" }, [
                    _createElementVNode("div", { class: "one spin-one" }),
                    _createElementVNode("div", { class: "two spin-two" }),
                    _createElementVNode("div", { class: "three spin-one" })
                  ], -1)
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}